'use client';
import { Video as SharedVideo } from '@launchstore/shared-puck';
import type { VideoProps } from '@launchstore/shared-puck';
export const Video: any = SharedVideo;
export type { VideoProps };
export default Video;
